import { useAppliances } from '@hakimo-ui/hakimo/data-access';
import { BasicPanel, QueryResult } from '@hakimo-ui/hakimo/ui-elements';
import { Table } from '@hakimo-ui/hakimo/ui-table';
import { useRowNavigation } from '@hakimo-ui/hakimo/util';
import { Alert } from '@hakimo-ui/shared/ui-base';
import { useMemo } from 'react';
import { tenantAppliancesParams } from './searchParams';
import { getTableData } from './util';

interface Props {
  tenantId: string;
}

export function AppliancesTableCard(props: Props) {
  const { tenantId } = props;
  const onClickRow = useRowNavigation('/appliances');
  const appliancesQuery = useAppliances(tenantAppliancesParams(tenantId));

  const tableData = useMemo(
    () => getTableData(appliancesQuery.data?.items ?? [], onClickRow, true),
    [appliancesQuery.data, onClickRow]
  );

  return (
    <BasicPanel title="Appliances">
      <QueryResult queryResult={appliancesQuery}>
        {(response) =>
          response.items.length === 0 ? (
            <div className="p-4">
              <Alert type="info" size="small">
                No appliances attached to this tenant.
              </Alert>
            </div>
          ) : (
            <Table data={tableData} embedded />
          )
        }
      </QueryResult>
    </BasicPanel>
  );
}

export default AppliancesTableCard;
